import { render, staticRenderFns } from "./Breaches.vue?vue&type=template&id=2cc02f78&"
import script from "./Breaches.vue?vue&type=script&lang=js&"
export * from "./Breaches.vue?vue&type=script&lang=js&"
import style0 from "./Breaches.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports